import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  headerBox: {
    display: "flex",
    justifyContent: "space-between",
  },
  box: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: '24px',
    marginBottom: '24px'
  },
  buttonGroup: {
    overflow: "hidden",
    border: "1px solid var(--primary - _states - outlinedBorder, rgba(33, 150, 243, 0.50)) !important",
    borderRadius: "var(--borderRadius, 4px)",
  },
  boxItemEnd: {
    marginTop: "auto",
    color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
    fontFeatureSettings: "'liga' off, 'clig' off",
    /* typography/body2 */
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    letterSpacing: "0.17px",
    weight: "400",
    lineHeight: "143%",
  },
  headerDisconnectionMgmt: {
    color: "var(--text- primary, rgba(0, 0, 0, 0.87))",
    fontFeatureSettings: "'liga' off, 'clig' off",
    /* typography/h5 */
    fontFamily: "Inter",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "133.4 %", /* 32.016px */
  },
  buttonActionFilters: {
    letterSpacing: "0.4px",
    "&.MuiButton-containedPrimary": {
      backgroundColor: "#2196f3 !important",
    }
  }
}));
